import { useCallback, useMemo, useState } from 'react';

const useShowAllToggle = <T>(items: T[], defaultMin: number) => {
  const [showAll, setShowAll] = useState(false);

  const visibleItems = useMemo(
    () => (showAll ? items : items.slice(0, defaultMin)),
    [items, showAll, defaultMin],
  );

  const toggleShowAll = useCallback(() => setShowAll((prev) => !prev), []);
  const resetShowAll = useCallback(() => setShowAll(false), []);

  return {
    showAll,
    visibleItems,
    hasMore: items.length > defaultMin,
    toggleShowAll,
    resetShowAll,
  };
};

export default useShowAllToggle;
